<template>
  <div class="room-details">
    <v-card :loading="isLoading">
      <template v-if="room">
        <v-img
          class="white--text"
          height="200px"
          src="https://source.unsplash.com/featured/?house"
        >
          <v-card-title class="align-end fill-height">{{ room.name }}</v-card-title>
        </v-img>
        <v-card-text>
          <div class="body-1">
            {{ room.address }} - {{ room.zip }} - {{ room.city }}
          </div>
          <br>
          <div class="body-1">
            Chambre actuellement {{ isOccupied ? 'occupée' : 'libre' }}
            <template v-if="isOccupied && user">
              par
              <v-btn depressed :to="`/users/${user.id}`">{{ user.name }}</v-btn>
            </template>
          </div>
        </v-card-text>
      </template>
    </v-card>
  </div>
</template>

<script>
import api from '@/plugins/APIWrapper';
import { reservationMixins } from '@/mixins';

export default {
  name: 'room-details',
  mixins: [reservationMixins],
  data() {
    return {
      user: null,
      room: null,
      isLoading: 'success',
    };
  },
  components: {},
  computed: {
    isOccupied() {
      return this.room.status === 'occupied';
    },
  },
  async mounted() {
    try {
      this.room = await api.getRoom(this.$route.params.id);
      const users = await api.getClients();
      this.user = users.find(user => user.roomId === this.room.id);
      this.isLoading = false;
    } catch (e) {
      console.error(e);
      this.isLoading = 'error';
    }
  },
};
</script>
